export const messagesEn = {
  addQuestion: 'Add question',
  addSection: 'Add section',
  addOption: 'Add option',
  addValidation: 'Add validation',
  saved: 'Saved',
  duplicate: 'Duplicate',
  delete: 'Delete',
  minimize: 'Minimize',
  documentValidation: {
    AllowOnlySpecificFileTypes: 'Allow only specific file types',
    filter: {
      image: 'image',
      spreadsheet: 'spreadsheet',
      document: 'document',
      presentation: 'presentation',
      pdf: 'pdf',
    }
  },
  condition: {
    closePopup: 'Close',
    relatedQuestion: 'In question',
    relatedSection: 'In section',
    popupTitle: 'Display condition',
    popupDesc: 'Pick an answer which must be selected to display this question',
    noQuestion: 'No question with possibilities',
  },
  placeholder: {
    question: {
      label: 'Question',
      description: 'Description',
      type: 'Type',
      required: 'Required',
    },
    section: {
      title: 'Titre de la section',
      description: 'Section description (optional)'
    },
    option: {
      label: 'Option',
    },
    validation: {
      MAX_LENGTH: 'Nombre de caractères maximum',
      MIN_LENGTH: 'Nombre de caractères minimum',
      EMAIL: 'email',
      PHONE: 'phone',
      REGEX: 'pattern',
    }
  },
  questionType: {
    RADIO: 'Radio',
    SELECT: 'Liste',
    TEXT: 'Text',
    LONGTEXT: 'Longtext',
    CHECKBOX: 'Checkbox',
    DATE: 'Date',
    DOCUMENT: 'DOCUMENT',
    LABEL: 'LABEL',
  },
  weight: {
    1: 1,
    2: 2,
    3: 3,
  }
}
